module.exports = __webpack_public_path__ + "d59e6dc2616c53ce8e77b161e094cca8.png";